import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'
import {
  type GetSearchPageStateQuery,
  GetSearchPageStateDocument,
} from '@kijiji/generated/graphql-types'

export const updateSearchPageCache = (
  apolloClient: ApolloClient<NormalizedCacheObject>,
  pageData: GetSearchPageStateQuery['searchState']
) => {
  apolloClient.cache.writeQuery({
    query: GetSearchPageStateDocument,
    data: { searchState: pageData },
  })
}
